import React from "react";
import './PortfolioCard.css'
import Typography from "@mui/material/Typography";
import {To, useNavigate} from "react-router-dom";

interface PortfolioCardProps {
    imageUrl: string;
    title: string;
    path: string;
    forward: string;
}

const PortfolioCard: React.FC<PortfolioCardProps> = ({ imageUrl, title, path, forward }) => {

    const navigate = useNavigate();
    const handleNavigation = (path: To) => {
        navigate(path);
        window.scrollTo(0, 0);
    };
    
    return(
        <>
            <div className="portfolio-card-container">
                <div className="portfolio-card" style={{backgroundImage: `url(${imageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center'}}/>
                <div className="white-card">
                    <div className="whitecard-content">
                        <div className="title-subtitle">
                            <Typography
                                sx={{
                                    color: '#82828a',
                                    fontFamily: "Kumbh Sans, sans-serif",
                                    fontWeight: 500,
                                    fontSize: '13px',
                                    letterSpacing: '1px',
                                    textTransform: 'uppercase'
                                }}
                            >
                                {title}
                            </Typography>
                            <br/>
                            <Typography
                                sx={{
                                    color: '#3b3b3b',
                                    fontFamily: "Kumbh Sans, sans-serif",
                                    fontWeight: 700,
                                    fontSize: '20px',
                                    marginTop: '-25px'
                                }}
                            >
                                {path}
                            </Typography>
                        </div>
                        <button className="button" onClick={() => handleNavigation(`${forward}`)}>
                            <div className="button-box">
                                <span className="button-elem">
                                  <svg viewBox="0 0 46 40" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M46 20.038c0-.7-.3-1.5-.8-2.1l-16-17c-1.1-1-3.2-1.4-4.4-.3-1.2 1.1-1.2 3.3 0 4.4l11.3 11.9H3c-1.7 0-3 1.3-3 3s1.3 3 3 3h33.1l-11.3 11.9c-1 1-1.2 3.3 0 4.4 1.2 1.1 3.3.8 4.4-.3l16-17c.5-.5.8-1.1.8-1.9z"
                                    ></path>
                                  </svg>
                                </span>
                                <span className="button-elem">
                                  <svg viewBox="0 0 46 40">
                                    <path
                                        d="M46 20.038c0-.7-.3-1.5-.8-2.1l-16-17c-1.1-1-3.2-1.4-4.4-.3-1.2 1.1-1.2 3.3 0 4.4l11.3 11.9H3c-1.7 0-3 1.3-3 3s1.3 3 3 3h33.1l-11.3 11.9c-1 1-1.2 3.3 0 4.4 1.2 1.1 3.3.8 4.4-.3l16-17c.5-.5.8-1.1.8-1.9z"
                                    ></path>
                                  </svg>
                                </span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PortfolioCard;